import { type ReactNode } from "react";
import { cn } from "~/utils/cn";

export default function Container({
  children,
  containerClass,
  anchorName = null,
}: {
  children: ReactNode;
  containerClass?: string;
  anchorName?: string | null;
}) {
  return (
    <div
      className={cn([
        "mx-auto w-full px-6 lg:px-24 xl:px-48",
        containerClass,
      ])}
      id={anchorName ? anchorName : undefined}
      data-anchor-name={anchorName ? anchorName : null}
    >
      {children}
    </div>
  );
}
